

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentPartCatalogBlock extends Vue {
  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: [String, Array], default: '' })
  text: string | Array<string>;

  @Prop({ type: String, default: '' })
  icon: string;

  @Prop({ type: Boolean, default: false })
  video: boolean;

  videoContent: Array<string> = [];

  get addClasses(): string {
    return this.icon ? `block_${this.icon}` : '';
  }

  mounted(): void {
    const { text } = this;
    if (Array.isArray(text) && text.length > 0) {
      this.videoContent = text;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/block/Block.vue